import React from "react";

const PrivacyPolicy = () => {
  return (
    <section className="min-h-screen flex flex-col justify-center items-center bg-slate-800 px-4">
      <div className="max-w-5xl mx-auto px-6 py-16 text-white">
        <h1 className="text-3xl sm:text-4xl font-bold mb-6 text-center pt-16">
          Política de Privacidade
        </h1>

        <p className="text-lg mb-6 text-justify">
          A <strong>Free Market Seguros</strong> valoriza a privacidade e a
          segurança das informações dos seus clientes. Esta Política de
          Privacidade explica como coletamos, utilizamos, armazenamos e
          protegemos os dados pessoais fornecidos por meio do nosso site e
          canais de atendimento.
        </p>

        <div className="space-y-8">
          <section>
            <h2 className="text-2xl font-semibold mb-2">1. Coleta de Dados</h2>
            <p className="text-justify">
              Coletamos dados pessoais por meio de formulários de contato,
              simulação de seguros, envio de propostas e atendimento
              personalizado. Os dados coletados podem incluir:
            </p>
            <ul className="list-disc list-inside mt-2 ml-4">
              <li>Nome completo</li>
              <li>Telefone e e-mail</li>
              <li>CPF e data de nascimento</li>
              <li>Informações do veículo e tipo de seguro desejado</li>
              <li>Demais dados relevantes para cotação ou contratação</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-2">
              2. Finalidade do Uso
            </h2>
            <p className="text-justify">
              Os dados pessoais são utilizados com as seguintes finalidades:
            </p>
            <ul className="list-disc list-inside mt-2 ml-4">
              <li>Realizar cotações de seguros com seguradoras parceiras</li>
              <li>Entrar em contato para esclarecimentos ou propostas</li>
              <li>Enviar comunicações sobre produtos, serviços e promoções</li>
              <li>Melhorar a experiência do usuário em nosso site</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-2">
              3. Compartilhamento de Informações
            </h2>
            <p className="text-justify">
              Seus dados poderão ser compartilhados com seguradoras parceiras
              exclusivamente para fins de cotação, emissão ou renovação de
              seguros. Não vendemos, alugamos ou compartilhamos suas informações
              com terceiros para fins comerciais não autorizados.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-2">
              4. Armazenamento e Segurança
            </h2>
            <p className="text-justify">
              Adotamos medidas técnicas e administrativas adequadas para
              proteger os dados pessoais contra acesso não autorizado, perda,
              alteração ou divulgação. As informações são armazenadas em
              sistemas seguros com acesso restrito.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-2">
              5. Direitos dos Titulares de Dados
            </h2>
            <p className="text-justify">
              De acordo com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018
              - LGPD), você tem o direito de:
            </p>
            <ul className="list-disc list-inside mt-2 ml-4">
              <li>Acessar os dados que temos sobre você</li>
              <li>Corrigir dados incompletos ou desatualizados</li>
              <li>Solicitar a exclusão dos seus dados pessoais</li>
              <li>Revogar o consentimento para uso dos seus dados</li>
              <li>Ser informado sobre com quem compartilhamos seus dados</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-2">
              6. Cookies e Tecnologias
            </h2>
            <p className="text-justify">
              Utilizamos cookies para melhorar sua experiência de navegação,
              medir desempenho e personalizar conteúdo. Você pode desativar os
              cookies nas configurações do seu navegador, mas isso pode afetar
              algumas funcionalidades do site.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-2">
              7. Alterações nesta Política
            </h2>
            <p className="text-justify">
              Esta política pode ser atualizada periodicamente para refletir
              mudanças legais ou operacionais. Recomendamos que você revise esta
              página regularmente para se manter informado.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-2">8. Contato</h2>
            <p className="text-justify">
              Em caso de dúvidas, solicitações ou para exercer seus direitos de
              titular de dados, entre em contato conosco:
            </p>
            <ul className="mt-2 ml-4">
              <li>
                <strong>E-mail:</strong>{" "}
                <a
                  href="mailto:contato@freemarketseguros.com.br"
                  className="text-blue-600 hover:underline"
                >
                  contato@freemarketseguros.com.br
                </a>
              </li>
              <li>
                <strong>Endereço:</strong> Rua Gameleiras, 141 2º e 3º Andar -
                São Gotardo/MG
              </li>
              <li>
                <strong>Telefone:</strong> (34) 3671-0349
              </li>
            </ul>
          </section>

          <p className="text-sm text-gray-500 text-right mt-8">
            Última atualização: 10 de julho de 2025
          </p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
